import React from "react";

import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom"

import c1 from '../../img/Home/c1.webp';
import c2 from '../../img/Home/c2.webp';
import c3 from '../../img/Home/c3.webp';

import Fade from 'react-reveal/Fade'

function CompcoreProducts () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative flex flex-col items-center">
                <p className="open-sans text-[#F26522] text-[28px] xl:text-[45px]">{t('home.14')}</p>
                <p className="text-[#F26522] open-sans text-[18px] xl:text-[20px] mt-[10px]">{t('home.15')}</p>
                <Fade bottom>
                    <div className="flex flex-wrap gap-[35px] mt-[50px] xl:mt-[65px]">
                        <div className="mx-auto">
                            <Link to="/composite-rein"><img src={c1} alt="" className="hover:scale-[1.1] transition-all"/></Link>
                            <p className="mt-[15px] open-sans font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6]">{t('home.16')}</p>
                        </div>
                        <div className="mx-auto">
                            <Link to="/composite-mesh"><img src={c2} alt="" className="hover:scale-[1.1] transition-all"/></Link>
                            <p className="mt-[15px] open-sans font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6]">{t('home.17')}</p>
                        </div>
                        <div className="mx-auto">
                            <Link to="/masonry-mesh"><img src={c3} alt="" className="hover:scale-[1.1] transition-all"/></Link>
                            <p className="mt-[15px] open-sans font-[300] text-[14px] xl:text-[16px] text-[#F6F6F6]">{t('home.18')}</p>
                        </div>
                    </div> 
                </Fade>
            </div>
        </div>
    );
}

export default CompcoreProducts;